module.exports = __webpack_public_path__ + "static/64c65c7422d5476f930c26650f3c882a64cda13bd9808a6faba77f30b05828d8-98fdf190375abc24c0f02e07a4c7e171.png";